module.exports = __webpack_public_path__ + "Times.39ecb708ec04ec992208.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Times.otf
// module id = 375
// module chunks = 8